export const calculateDurationString = (
  startTime: string,
  val: string,
): string => {
  const [startHour, startMinute] = startTime.split(":").map(Number);
  const [targetHour, targetMinute] = val.split(":").map(Number);

  const startTimeInMinutes = (startHour ?? 0) * 60 + (startMinute ?? 0);
  const targetTimeInMinutes = (targetHour ?? 0) * 60 + (targetMinute ?? 0);

  let durationInMinutes = targetTimeInMinutes - startTimeInMinutes;
  if (durationInMinutes < 0) durationInMinutes += 24 * 60;

  const hours = Math.floor(durationInMinutes / 60);
  const minutes = durationInMinutes % 60;

  return `${hours}:${minutes.toString().padStart(2, "0")}`;
};

export const recalculateEndTime = (
  startTime: string,
  duration: string,
): string => {
  if (!startTime || !duration) return "Invalid input";

  const [startHour, startMinute] = startTime.split(":").map(Number);
  const [durationHour, durationMinute] = duration.split(":").map(Number);

  let totalMinutes = (startHour ?? 0) * 60 + (startMinute ?? 0);
  totalMinutes += (durationHour ?? 0) * 60 + (durationMinute ?? 0);

  const endHour = Math.floor(totalMinutes / 60) % 24;
  const endMinute = totalMinutes % 60;

  return `${endHour.toString().padStart(2, "0")}:${endMinute.toString().padStart(2, "0")}`;
};

export const addMinutesToTimeString = (
  timeString: string,
  minutesToAdd: number,
): string => {
  const [hourStr, minuteStr] = timeString.split(":");

  const hour = parseInt(hourStr ?? "", 10);
  const minute = parseInt(minuteStr ?? "", 10);

  const totalMinutes = hour * 60 + minute + minutesToAdd;
  const newHour = Math.floor(totalMinutes / 60) % 24;
  const newMinute = totalMinutes % 60;

  return `${newHour.toString().padStart(2, "0")}:${newMinute.toString().padStart(2, "0")}`;
};

export const calculateDuration = (startDate: Date, endDate: Date): number => {
  if (!startDate || !endDate) return 0;

  const diffMs = endDate.getTime() - startDate.getTime();
  const diffHours = diffMs / (1000 * 60 * 60);

  return diffHours;
};

export const isMultiDayEvent = (startDate: Date, endDate: Date) => {
  const eventDuration = calculateDuration(startDate, endDate);

  return eventDuration >= 24;
};

export const getAdjustedEndDateFromTimeString = (
  val: string,
  startDate: Date | null,
  endDate: Date | null,
  isMultiDayEvent: (start: Date, end: Date) => boolean,
): Date | null => {
  const value = val.split(":");
  if (value.length !== 2 || !startDate || !endDate) return null;

  const newEndHours = parseInt(value[0] ?? "", 10);
  const newEndMinutes = parseInt(value[1] ?? "", 10);
  const originalEndHours = endDate.getHours();
  const originalEndMinutes = endDate.getMinutes();

  const newEndDate = new Date(endDate);
  newEndDate.setHours(newEndHours, newEndMinutes);

  const startHours = startDate.getHours();
  const startMinutes = startDate.getMinutes();

  const startDay = startDate.getDate();
  const endDay = newEndDate.getDate();

  const multiDay = isMultiDayEvent(startDate, endDate);

  if (!multiDay) {
    if (
      originalEndHours < startHours ||
      (originalEndHours === startHours && originalEndMinutes < startMinutes)
    ) {
      if (
        newEndHours < startHours ||
        (newEndHours === startHours && newEndMinutes <= startMinutes)
      ) {
        newEndDate.setDate(newEndDate.getDate());
      } else {
        newEndDate.setDate(newEndDate.getDate() - 1);
      }
    } else if (startDay === endDay) {
      if (
        newEndHours < startHours ||
        (newEndHours === startHours && newEndMinutes <= startMinutes)
      ) {
        newEndDate.setDate(newEndDate.getDate() + 1);
      } else {
        newEndDate.setDate(newEndDate.getDate());
      }
    }
  }

  return newEndDate;
};

export const calculateNewStartDate = (startDate: Date, timeString: string) => {
  const newStartDate = new Date(startDate ?? "");
  const newTimeString = timeString.split(":");
  if (newTimeString.length == 2) {
    const hours = parseInt(newTimeString[0] ?? "");
    const minutes = parseInt(newTimeString[1] ?? "");

    newStartDate.setHours(hours, minutes);
  }

  return newStartDate;
};

export const calculateNewEndDate = (
  startDate: Date,
  endDate: Date,
  newEndTime: string,
  newStartDate: Date,
) => {
  const newEndDate = new Date(endDate ?? "");
  const originalStartHours = startDate?.getHours() ?? 0;
  const originalStartMinutes = startDate?.getMinutes() ?? 0;
  const originalEndHours = endDate?.getHours() ?? 0;
  const originalEndMinutes = endDate?.getMinutes() ?? 0;

  const newEndTimeSplit = newEndTime.split(":");
  const newEndTimeHours = parseInt(newEndTimeSplit[0] ?? "");
  const newEndTimeMinutes = parseInt(newEndTimeSplit[1] ?? "");

  newEndDate.setHours(newEndTimeHours, newEndTimeMinutes);

  const newStartHours = newStartDate?.getHours() ?? 0;
  const newStartMinutes = newStartDate?.getMinutes() ?? 0;

  //recalculate end date day
  if (endDate) {
    if (
      originalEndHours > newEndTimeHours ||
      (originalEndHours === newEndTimeHours &&
        originalEndMinutes > newEndTimeMinutes)
    ) {
      if (
        originalStartHours < newStartHours ||
        (originalStartHours === newStartHours &&
          originalStartMinutes <= newStartMinutes)
      ) {
        newEndDate.setDate(newEndDate.getDate() + 1);
      }
    } else if (
      originalEndHours < newEndTimeHours ||
      (originalEndHours === newEndTimeHours &&
        originalEndMinutes < newEndTimeMinutes)
    ) {
      if (
        originalStartHours > newStartHours ||
        (originalStartHours === newStartHours &&
          originalStartMinutes > newStartMinutes)
      ) {
        newEndDate.setDate(newEndDate.getDate() - 1);
      }
    }
  }

  return newEndDate;
};
